import { ExpressedOutcomeEnum, Text } from '@talos/kyoko';
import { PredictionLegTag } from './styles';

interface PredictionOutcomeProps {
  outcome?: ExpressedOutcomeEnum;
}

export function PredictionOutcomeTag({ outcome }: PredictionOutcomeProps) {
  if (outcome == null) {
    return null;
  }

  const leg = outcome === ExpressedOutcomeEnum.Yes ? 'yes' : 'no';

  return (
    <PredictionLegTag $leg={leg} data-testid="prediction-order-outcome">
      {outcome}
    </PredictionLegTag>
  );
}

export function PredictionOutcomeText({ outcome }: PredictionOutcomeProps) {
  if (outcome == null) {
    return null;
  }

  return (
    <Text
      color={outcome === ExpressedOutcomeEnum.Yes ? 'colorTextPositive' : 'colorTextNegative'}
      data-testid="prediction-order-outcome"
    >
      {outcome}
    </Text>
  );
}
